import React, { useEffect, useRef, useState } from 'react';
import QuadLog from '../images/headerImages/quad-control-logo.png';
import '../css/header.css'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faKey, faPowerOff, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
const Header = () => {
    const mediaRecorderRef = useRef(null /** @type {MediaRecorder|null} */);
    const displayStreamRef = useRef(null /** @type {MediaStream|null} */);
    const mixedStreamRef = useRef(null /** @type {MediaStream|null} */);
  
    const [isRecording, setIsRecording] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [micEnabled, setMicEnabled] = useState(true);
    const [blobUrl, setBlobUrl] = useState("");
    const [fileName, setFileName] = useState(() => `screen-recording-${Date.now()}.webm`);
    const [duration, setDuration] = useState(0); // seconds
    const [error, setError] = useState("");
  
    const chunksRef = useRef([] /** @type {BlobPart[]} */);
    const timerRef = useRef(null /** @type {number|null} */);
 
    

    const LogoutFun = () => {
      localStorage.clear();
    };
  return (
    <>
      <div className="horizontal-layout horizontal-menu  navbar-floating footer-static  " data-open="hover" data-menu="horizontal-menu" data-col="">
         <nav className="header-navbar navbar-expand-lg navbar navbar-fixed align-items-center navbar-shadow navbar-brand-center" data-nav="brand-center">
        <div className="navbar-container d-flex content ">
            <div className="bookmark-wrapper d-flex align-items-center">
              <img className="dashboard_img" height={56} width={53} src={QuadLog} /></div>
          <div className="quad_logCls"><h5 className="logo-title mb-0">Quad Control</h5>
          <span className="logo-subtitle">Remote Device Access &amp; Diagnostics</span>
            </div>
            <ul className="nav navbar-nav align-items-center ms-auto">
             
        
            {/* { localStorage.getItem('userRole') == "user" && !isRecording && (
          <>
           <button onClick={start} style={btn()}>Start</button> <br />
            <div>
             
            </div>
          </>
        )}
        {isRecording && !isPaused && (
          <button onClick={pause} style={btn()}>Pause</button>
        )}
        {isRecording && isPaused && (
          <button onClick={resume} style={btn()}>Resume</button>
        )}
        {isRecording && (
          <button onClick={stop} style={btn("danger")}>Stop</button>
        )}
        {!!blobUrl && (
          <>
            <button onClick={download} style={btn("primary")}>Download</button>
            <button onClick={handleUploadToServer} style={btn()}>Upload</button>
            <button onClick={() => { URL.revokeObjectURL(blobUrl); setBlobUrl(""); }} style={btn()}>Clear</button>
          </>
        )} */}
             
               {/*  <li className="nav-item dropdown dropdown-user"><a className="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div className="user-nav d-sm-flex d-none"><span  className="text-capitalize">Recording Time : </span><span className='bg-light-primary'>{`00:00:00`}</span></div>
                    </a>
                    
                </li> */}
                <li className="nav-item dropdown dropdown-user"><a className="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div className="user-nav d-sm-flex d-none"><span className="user-name fw-bolder text-capitalize">{localStorage.getItem('fullName')}</span><span className="user-status">{localStorage.getItem('userRole')}</span></div><span className="avatar"><img className="round" src="../../../app-assets//images/portrait/small/avatar-s-11.jpg" alt="avatar" height="40" width="40" /><span className="avatar-status-online"></span></span>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdown-user">
                      {localStorage.getItem('userRole') === 'admin' && (
                        <Link className="dropdown-item" to="/api-keys"><FontAwesomeIcon size='md' icon={faKey} /> API Keys</Link>
                      )}
                      {localStorage.getItem('userRole') === 'superadmin' && (
                        <Link className="dropdown-item" to="/super-admin/api-keys"><FontAwesomeIcon size='md' icon={faKey} /> API Keys</Link>
                      )}
                      {localStorage.getItem('userRole') === 'superadmin' && (
                        <Link className="dropdown-item" to="/super-admin/mfa-setup"><FontAwesomeIcon size='md' icon={faShieldHalved} /> MFA Setup</Link>
                      )}
                      <a className="dropdown-item" href="/" onClick={LogoutFun}><FontAwesomeIcon size='md' icon={faPowerOff } /> Logout</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
   

    </div>
   
    </>
  )
}

export default Header